module.exports = __webpack_public_path__ + "img/consent_withdraw.3ff91931.svg";